import { render, staticRenderFns } from "./CampOrder.vue?vue&type=template&id=4b799abc&scoped=true&"
import script from "./CampOrder.vue?vue&type=script&lang=js&"
export * from "./CampOrder.vue?vue&type=script&lang=js&"
import style0 from "./CampOrder.vue?vue&type=style&index=0&id=4b799abc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b799abc",
  null
  
)

export default component.exports